import { Link } from "react-router-dom";
import { ArrowRight, Clock, Gift, Send, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useConfig } from "../context/ConfigContext";

export const ProefboxBlock = ({ box, shots, onRequest }) => {
  const { addItem } = useCart();
  const { ecommerceEnabled } = useConfig();
  const variant = (box.variants || []).find((v) => v.popular) || box.variants?.[0];
  const comingSoon = !!box.coming_soon;

  const addToCart = () =>
    variant &&
    addItem({ id: variant.id, name: variant.label.startsWith(box.name) ? variant.label : `${box.name} — ${variant.label}`, price: variant.price, units: variant.units, image: box.image }, 1);

  return (
    <section data-testid="home-proefbox-block" className="relative overflow-hidden border-t border-[var(--tha-border)] bg-[#070707]">
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full opacity-30 pointer-events-none" style={{ background: "radial-gradient(circle, rgba(255,30,30,0.45) 0%, transparent 70%)", filter: "blur(70px)" }} />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/3] border border-[var(--tha-border)] overflow-hidden group">
            <img src={box.image} alt={box.name} data-testid="proefbox-image" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 55%, rgba(5,5,5,0.85) 100%)" }} />
            {box.badge && (
              <div className="absolute top-5 left-5 bg-[var(--tha-red)] text-black px-3 py-1.5 text-[10px] font-mono-x tracking-[0.3em]">{box.badge}</div>
            )}
          </div>
          <div className="hidden sm:flex absolute -bottom-6 -right-6 w-28 h-28 rounded-full bg-[var(--tha-red)] text-black items-center justify-center text-center rotate-12 shadow-[0_0_40px_rgba(255,30,30,0.5)]">
            <div className="font-display text-lg leading-none">ALLE 3<br />SMAKEN</div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="flex items-center gap-3">
            <span className="h-px w-12 bg-[var(--tha-red)]" />
            <span className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-red)] inline-flex items-center gap-2"><Gift size={12} /> NIEUW HIER? BEGIN HIER</span>
          </div>
          <h2 className="font-display text-5xl sm:text-7xl mt-6 leading-[0.9]">
            NIET KUNNEN KIEZEN?
            <br />
            <span className="neon-red-text">PROEF ZE ALLEMAAL.</span>
          </h2>
          <p className="mt-6 text-[var(--tha-muted)] max-w-lg leading-relaxed">{box.tagline || box.description}</p>

          <div className="mt-8 flex flex-wrap gap-2">
            {shots.map((s) => (
              <span key={s.id} data-testid={`proefbox-flavour-${s.id}`} className="inline-flex items-center gap-2 border px-3 py-2 text-[11px] font-mono-x tracking-widest" style={{ borderColor: `${s.accent_color || "#ff1e1e"}88` }}>
                <span className="w-2 h-2 rounded-full" style={{ background: s.accent_color || "#ff1e1e" }} />
                {s.name.toUpperCase()} · {s.alcohol}
              </span>
            ))}
          </div>

          {ecommerceEnabled && !comingSoon && variant && (
            <div data-testid="proefbox-price" className="mt-8 font-display text-4xl">€ {variant.price.toFixed(2)}</div>
          )}

          <div className="mt-8 flex flex-wrap gap-3">
            {comingSoon ? (
              <Link to="/shop?tab=box" data-testid="proefbox-coming-soon-cta" className="btn-red px-7 py-4 font-display tracking-wider inline-flex items-center gap-2">
                <Clock size={16} /> BINNENKORT — MELD JE AAN
              </Link>
            ) : ecommerceEnabled ? (
              <button onClick={addToCart} data-testid="proefbox-add-to-cart" className="btn-red px-7 py-4 font-display tracking-wider inline-flex items-center gap-2">
                <ShoppingBag size={16} /> IN MANDJE
              </button>
            ) : (
              <button onClick={() => onRequest(box, variant)} data-testid="proefbox-request" className="btn-red px-7 py-4 font-display tracking-wider inline-flex items-center gap-2">
                <Send size={16} /> AANVRAGEN
              </button>
            )}
            <Link to="/shop?tab=box" data-testid="proefbox-shop-link" className="btn-ghost-red px-7 py-4 font-display tracking-wider inline-flex items-center gap-2">
              BEKIJK IN SHOP <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
